import {toast} from "react-toastify";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";

const OnLoginHandler = async (sendData, formStep, textCaptcha, setIsAuth, setFormStep, setSendData) => {

  if (formStep === "LOGIN") {
    if (sendData?.user === "") {
      return toast.error("نام کاربری خود را وارد کنید")
    }
    if (sendData?.pass === "") {
      return toast.error("رمز عبور خود را وارد کنید")
    }
    if (sendData?.captchaInput.toUpperCase() !== textCaptcha.toUpperCase()) {
      return toast.error("حروف تصویر را به درستی وارد کنید")
    }

    const formData = new FormData();
    formData.append("user", sendData?.user);
    formData.append("pass", sendData?.pass);

    const response = await _axios.post(prefixUrl() + "/check_user/", formData)
    if (response?.data?.status) {
      for (const key in response?.data) {
        localStorage.setItem(key, response?.data[key]);
      }
      setIsAuth(true);
    } else {
      toast.error(response?.data?.message);
    }
  }

  if (formStep === "FORGET") {
    if (sendData?.mobileNumber === "") {
      return toast.error("شماره موبایل خود را به درستی وارد کنید")
    }
    if (sendData?.captchaInput.toUpperCase() !== textCaptcha.toUpperCase()) {
      return toast.error("حروف تصویر را به درستی وارد کنید")
    }

    const response = await _axios.get(prefixUrl() + "/password/?mobileNumber=" + sendData?.mobileNumber)
    if (response.data.status) {
      toast.success(response?.data?.message)
      setFormStep("VERIFY")
    } else {
      toast.error(response?.data?.message);
    }
  }

  if (formStep === "VERIFY") {
    if (sendData?.code.length !== 5) {
      return toast.error("کد تایید را به درستی وارد کنید")
    }

    const formData = new FormData();
    formData.append("code", sendData?.code);

    const response = await _axios.post(prefixUrl() + "/password/", formData)
    if (response.data.status) {
      toast.success(response?.data?.message)
      setSendData({...sendData, user: response?.data?.user})
      setFormStep("NEW_PASSWORD")
    } else {
      toast.error(response?.data?.message);
    }
  }

  if (formStep === "NEW_PASSWORD") {

    if (sendData?.password === "") {
      return toast.error("رمز عبور جدید خود را وارد کنید")
    }
    if (sendData?.repeatPass === "") {
      return toast.error("تکرار رمز عبور خود را وارد کنید")
    }
    if (sendData?.password !== sendData?.repeatPass) {
      return toast.error("تکرار رمز عبور اشتباه است")
    }

    const response = await _axios.put(prefixUrl() + "/password/", sendData)
    if (response?.data?.status) {
      toast.success(response?.data?.message)
      setSendData({
        ...sendData,
        captchaInput: "",
        pass: "",
        mobileNumber: "",
        code: "",
        password: "",
        repeatPass: "",
      })
      setFormStep("LOGIN")
    } else {
      toast.error(response?.data?.message);
    }
  }

};

export default OnLoginHandler;